import { Map, Marker } from 'google-maps-react'
import React from 'react'
import Search from './Search'

import './index.scss'

const GoogleMaps = ({
  google,
  onSetMarker,
  initialCenter,
  markerPosition,
  zoom,
}) => {
  const handleMapClick = (_mapProps, _map, clickEvent) => {
    const lat = clickEvent.latLng.lat()
    const lng = clickEvent.latLng.lng()

    onSetMarker({ lat: lat, lng: lng })
  }

  const handleMarkerClick = () => {
    onSetMarker(null)
  }

  return (
    <>
      <div className="google-maps-search">
        <Search onSearchAddressSelect={onSetMarker} />
      </div>
      <div className="googlemaps-wrapper">
        <Map
          google={google}
          onClick={handleMapClick}
          initialCenter={initialCenter}
          center={markerPosition ? markerPosition : initialCenter}
          zoom={zoom}
        >
          {markerPosition && (
            <Marker position={markerPosition} onClick={handleMarkerClick} />
          )}
        </Map>
      </div>
    </>
  )
}

export default GoogleMaps
